export const environment = {
  name: 'dev',
  apiUrl: 'https://dev.trueface.co.in',
  production: false
};